import { FiCheck } from 'react-icons/fi';

const safetyItems = [
  { label: 'UK Gambling Commission License', checked: true },
  { label: 'SSL Encryption', checked: true },
  { label: 'Responsible Gambling Tools', checked: true },
  { label: 'Secure Payment Methods', checked: true },
  { label: 'Regular Audits', checked: true },
  { label: 'Data Protection Compliant', checked: true },
];

export const SafetyChecklist: React.FC = () => {
  return (
    <div className="glass-card p-6">
      <h3 className="text-2xl font-bold text-primary-green mb-4">Safety Checklist</h3>
      <div className="space-y-3">
        {safetyItems.map((item, index) => (
          <div key={index} className="flex items-center gap-3">
            <div className={`flex-shrink-0 w-6 h-6 rounded border-2 flex items-center justify-center ${
              item.checked
                ? 'bg-primary-green border-primary-green'
                : 'border-gray-600'
            }`}>
              {item.checked && <FiCheck className="text-black" size={16} />}
            </div>
            <span className={`text-sm ${
              item.checked ? 'text-white' : 'text-gray-500'
            }`}>
              {item.label}
            </span>
          </div>
        ))}
      </div>
      <p className="mt-4 text-xs text-gray-400">
        All reviewed casinos meet these essential safety standards for UK players.
      </p>
    </div>
  );
};

